import React, {useRef, useState, useEffect} from "react";
import {Col, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap/Table";
import Pagination from "../../components/common/Pagination";
import TableTopBar from "../../components/tables/top/TableTopBar";
import AxcBadge from "../../components/common/AxcBadge";
import {getFHListAll} from "../../api/apiClient";
import Swal from "sweetalert2";
import Moment from "moment";
import Button from "react-bootstrap/Button";
import FaultMgmt from "../../pages/subPages/FaultMgmt";
import PopUp from "../popUp/PopUp";
import {exportExcel} from "../../common/exportExcel";
import {exportPdf} from "../../common/exportPdf";
import useAuth from "../../hook/useAuth";
import usePdf from "../../hook/usePdf";

const TableFR = ({
                   currentPage,
                   setCurrentPage,
                   listPageSize,
                   setListPageSize,
                   total,
                   tableList,
                   getFullData = null,
                   setIsSearch,
                   setTableList,
                   setTotal,
                   updateList,
                   searchParam,
                   setSearchParam,
                   propNavData
                 }) => {

  /*const [auth, setAuth] = useState("0");

  useEffect(() => {
    setAuth(sessionStorage.getItem("CURRENT_AUTH"));
  }, []);*/

  const auth = useAuth();

  // select ////////////////////////////////////
  const updatePageSize = (aSize) => {
    setIsSearch(true);
    setCurrentPage(1);
    setListPageSize(parseInt(aSize));
  };

  const tableRef = useRef(null);
  const [isExport, setIsExport] = useState(false);

  const onDownload = () => {
    exportExcel(tableRef, "장애조치현황_.xls")
  }

  const getAllList = () => {
    setIsExport(true);

    getFHListAll(
        searchParam.searchFcltyNo,
        Moment(searchParam.startDate).format('YYYY-MM-DD'),
        searchParam.searchFromSi,
        searchParam.searchLcKnd,
        searchParam.searchMssage,
        searchParam.searchSeriusLevel,
        searchParam.searchSttus,
        Moment(searchParam.endDate).format('YYYY-MM-DD'),
        searchParam.searchToSi
    ).then((res) => {
          // console.log(res);
          if (res.data.data !== undefined) {
            setTableList(res.data.data.list);
            setTotal(res.data.data.total);
          }
        }
    );
  };

  const downloadExcelToTable = () => {
    getAllList();

    Swal.fire({
      title: `EXCEL 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
      }
      setIsExport(false);
      updateList();
    })
  };

  const exportReport = () => {
    getAllList();

    Swal.fire({
      title: `PDF 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        exportPdf(tableRef, '장애조치현황.pdf');
      }
      setIsExport(false);
      updateList();
    });
  };

  // popup
  const [stPopup, setPopup] = useState(false);
  const [stPopupId, setPopupId] = useState({
    rcpt_no: '',
  });

  const openPopup = (rcpt_no) => {
    setPopupId({
      rcpt_no: rcpt_no,
    });
    setPopup(true);
  };

  const closePopup = () => {
    setPopup(false);
    setIsSearch(true);
    updateList();
  };

  const onClickDetail = (str) => {
    if (str != '' && str != null) {
      Swal.fire({
        title: '전체 내용',
        html: '<textarea class="swal2-textarea w-75"  disabled>' +
            str +
            '</textarea>'
      })
    }
  }

  useEffect(() => {
    console.log(propNavData);
    if (propNavData.isPopupOpen) {
      openPopup(propNavData.rcpt_no);
    }
  }, [propNavData]);


  return (
      <>
        <PopUp
            propTitle={'장애 조치'}
            propShow={stPopup}
            propSize={'lg'}
            setShow={closePopup}
        >
          <FaultMgmt
              propRcptNo={stPopupId.rcpt_no}
              hClose={closePopup}
          />
        </PopUp>
        <Row>
          <Col md={6} className={""}>
            <TableTopBar
                propSelectOption={{
                  isEnable: true,
                  selItems: [15, 30, 50], //미구현
                  setFunc: updatePageSize,
                }}
                propExcelExport={{
                  isEnable: true,
                  exportFilename: 'doc.xlsx',
                  getFunc: getFullData,
                }}
                propExcelDownload={{
                  isEnable: true,
                  getFunc: downloadExcelToTable,
                }}
                /*propPdfExport={{
                  isEnable: true,
                  // exportFilename: 'doc.pdf',
                  getFunc: exportReport,
                }}*/
                propPdf={{
                  isEnable: true,
                  getFunc: usePdf({
                    tableRef: tableRef,
                    setIsExport: setIsExport,
                    getAllList: getAllList,
                    updateList: updateList,
                    filename: '장애조치현황',
                  }),
                }}
                propDelete={{
                  isEnable: false,
                  // delFunc: delItem,
                }}
                propReg={{
                  isEnable: false,
                  // regFunc: regItem,
                }}
                // propControl = {{
                //     isEnable: true,
                //     ctlFunc: null,
                // }}
            />
          </Col>

          <Col md={12}>
            <div className={"table-responsive text-nowrap"}>
              <BootstrapTable hover className={"table text-center"} ref={tableRef}>
                <thead className={"table-head text-secondary"}>
                <tr className={"text-start"}>
                  <th className={"col"}>등급</th>
                  <th className={"col"}>접수코드</th>
                  {/*/!*<th className={"col"}>발생시간</th>*/}
                  {/*<th className={"col"}>장애이벤트</th>*/}
                  <th className={"col"}>상태</th>
                  {/*<th className={"col"}>복구유형</th>*/}
                  {/*<th className={"col"}>발생위치</th>*/}
                  <th className={"col"}>복구시간</th>
                  <th className={"col"}>조치일시</th>
                  <th className={"col-2"}>조치결과</th>
                  <th className={"col"}>조치자</th>
                  <th className={"col"}>복구기한</th>
                  <th className={"col-2"}>미복구사유</th>
                  {!isExport && auth === "2" ? <th className={"col"}></th> : ''}
                </tr>
                </thead>
                <tbody className={`table-body text-start ${isExport ? "" : "text-white"} `}>
                {
                  Array.isArray(tableList) ?
                      (tableList.map((elem, idx) => {
                        let rm_tmp = '' + elem.recovry_message;
                        if (rm_tmp.length > 10) {
                          rm_tmp = rm_tmp.substring(0, 10) + '...';
                        } else {
                          rm_tmp = elem.recovry_message;
                        }

                        let yr_tmp = '' + elem.ytrtd_resn;
                        if (yr_tmp.length > 10) {
                          yr_tmp = yr_tmp.substring(0, 10) + '...';
                        } else {
                          yr_tmp = elem.ytrtd_resn;
                        }
                        return <tr key={idx}>
                          <td>
                            <AxcBadge
                                propInput={elem.serius_level_nm}
                                propDangerText={'Critical'}
                                propWarningText={'Major'}
                                propMinorWarningText={'Minor'}
                            />
                          </td>
                          <td>{elem.rcpt_no}</td>
                          {/*<td>{elem.ocrn_dt_str}</td>*/}
                          {/*<td>{elem.cause_nm}</td>*/}
                          <td>{elem.sttus_nm}</td>
                          {/*<td>{elem.recovry_ty_nm}</td>*/}
                          {/*<td>{elem.mssage}</td>*/}
                          <td>{elem.recovry_dt_str}</td>
                          <td>{elem.managt_dt_str}</td>
                          <td onClick={(e) => {
                            onClickDetail(elem.recovry_message);
                          }}
                          >
                            {rm_tmp}</td>
                          <td>{elem.recovry_user_id}</td>
                          <td>{elem.recovry_term_str}</td>
                          <td onClick={(e) => {
                            onClickDetail(elem.ytrtd_resn);
                          }}>
                            {yr_tmp}</td>
                          {
                            !isExport && auth === "2" ?
                                (
                                    elem.sttus === 0 ?
                                        <td>
                                          <Button type={"button"} variant="primary"
                                                  data-rcpt-no={elem.rcpt_no}
                                                  onClick={(e) => {
                                                    // console.log(elem.rcpt_no);
                                                    openPopup(elem.rcpt_no);
                                                  }}
                                          >
                                            복구완료
                                          </Button>
                                        </td>
                                        :
                                        <td>
                                          <Button type={"button"} variant="danger"
                                                  data-rcpt-no={elem.rcpt_no}
                                                  onClick={(e) => {
                                                    // console.log(elem.rcpt_no);
                                                    openPopup(elem.rcpt_no);
                                                  }}
                                                  className={"px-1"}
                                          >
                                            &nbsp;&nbsp;&nbsp;미복구&nbsp;&nbsp;&nbsp;
                                          </Button>
                                        </td>
                                )
                                :
                                <></>
                          }
                        </tr>;
                      })) :
                      ('')
                }
                </tbody>
              </BootstrapTable>
            </div>
          </Col>
          <Col className={""}>
            <Pagination
                propCurPage={currentPage}
                propTotal={total}
                propPageSize={listPageSize}
                propSetNewPage={setCurrentPage}
                propSetIsSearch={setIsSearch}
            />
          </Col>
        </Row>
      </>
  );
};


export default TableFR;
